export default __webpack_public_path__ + "static/media/red_down.c926a14f.svg";